import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import useActiveSection from "../hooks/useActiveSection";

const LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "stack", label: "Stack" },
  { id: "projects", label: "Projects" },
  { id: "youtube", label: "YouTube" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const active = useActiveSection();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: scrolled ? "rgba(5,5,8,0.75)" : "transparent",
        backdropFilter: scrolled ? "blur(14px)" : "none",
        borderBottom: scrolled ? "1px solid var(--border)" : "1px solid transparent",
        transition: "background 0.3s ease, border-color 0.3s ease",
      }}
    >
      <div
        className="container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: 76,
        }}
      >
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            scrollTo("home");
          }}
          style={{ display: "flex", alignItems: "center", gap: 10, fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 16 }}
        >
          <span
            style={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              padding: 2,
              background: "var(--gradient)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/gaurav-avatar.jpg`}
              alt="Gaurav Bhadauria logo"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid var(--bg)",
              }}
            />
          </span>
          <span>
            Gaurav <span style={{ color: "var(--accent)" }}>Bhadauria</span>
          </span>
        </a>

        <nav className="desktop-nav" style={{ display: "flex", gap: 4 }}>
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              style={{
                background: "none",
                border: "none",
                color: active === l.id ? "var(--text)" : "var(--text-muted)",
                fontSize: 14,
                fontWeight: 500,
                padding: "8px 16px",
                borderRadius: 999,
                position: "relative",
                transition: "color 0.2s ease",
              }}
            >
              {active === l.id && (
                <motion.span
                  layoutId="nav-pill"
                  style={{
                    position: "absolute",
                    inset: 0,
                    borderRadius: 999,
                    background: "var(--surface-2)",
                    border: "1px solid var(--border-strong)",
                    zIndex: -1,
                  }}
                />
              )}
              {l.label}
            </button>
          ))}
        </nav>

        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo("contact"); }} className="btn btn-primary desktop-only" style={{ padding: "10px 20px", fontSize: 14 }}>
            Let's Talk
          </a>
          <button
            className="mobile-only"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle menu"
            style={{
              background: "var(--surface)",
              border: "1px solid var(--border-strong)",
              borderRadius: 10,
              width: 42,
              height: 42,
              display: "none",
              alignItems: "center",
              justifyContent: "center",
              color: "var(--text)",
            }}
          >
            {menuOpen ? "✕" : "☰"}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            style={{ overflow: "hidden", background: "rgba(5,5,8,0.95)", borderTop: "1px solid var(--border)" }}
            className="mobile-only"
          >
            <nav aria-label="Mobile navigation" style={{ display: "flex", flexDirection: "column", padding: 20, gap: 4 }}>
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => scrollTo(l.id)}
                  style={{
                    background: "none",
                    border: "none",
                    color: active === l.id ? "var(--accent)" : "var(--text-muted)",
                    fontSize: 16,
                    fontWeight: 500,
                    padding: "12px 0",
                    textAlign: "left",
                  }}
                >
                  {l.label}
                </button>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        @media (max-width: 860px) {
          .desktop-nav, .desktop-only { display: none !important; }
          .mobile-only { display: flex !important; }
        }
        @media (min-width: 861px) {
          .mobile-only { display: none !important; }
        }
      `}</style>
    </motion.header>
  );
}
